import React from 'react';
import { Card, Row, Col, Select } from 'antd';
import { DatePicker } from 'antd';
import moment from 'moment';
import { TimeRange } from '../hooks/useTimeRange';

const { Option } = Select;
const { RangePicker } = DatePicker;

interface TimeRangeSelectorProps {
  timeRange: TimeRange;
  customDateRange: [moment.Moment, moment.Moment] | null;
  onTimeRangeChange: (value: TimeRange) => void;
  onCustomDateRangeChange: (dates: [moment.Moment, moment.Moment] | null) => void;
}

const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({
  timeRange,
  customDateRange,
  onTimeRangeChange,
  onCustomDateRangeChange,
}) => {
  return (
    <Card style={{ marginBottom: 24 }}>
      <Row gutter={16} align="middle">
        <Col>
          <span style={{ marginRight: 8 }}>Time Range:</span>
          <Select value={timeRange} onChange={onTimeRangeChange} style={{ width: 150 }}>
            <Option value="daily">Last 24 Hours</Option>
            <Option value="weekly">Last 7 Days</Option>
            <Option value="monthly">Last 30 Days</Option>
            <Option value="custom">Custom Range</Option>
          </Select>
        </Col>
        {timeRange === 'custom' && (
          <Col>
            <RangePicker
              showTime
              value={customDateRange}
              onChange={(dates) => onCustomDateRangeChange(dates as [moment.Moment, moment.Moment] | null)}
              format="YYYY-MM-DD HH:mm"
            />
          </Col>
        )}
      </Row>
    </Card>
  );
};

export default TimeRangeSelector;
